<template>
  <FaqLayout />
</template>

<script>
import FaqLayout from '../components/FaqLayout.vue'
export default {
    name: 'App',
    components: {
        FaqLayout
    }
}
</script>
